import React, { memo, useEffect, useState } from "react";
import {
  Card,
  Col,
  Form,
  Row
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import "./index.css";

import { Creators as LoadersActions } from "../../store/ducks/loaders";
import { Creators as ChipsActions } from "../../store/ducks/chips";

import { mergeObject } from "../../utils/Object";
import { isScopes } from "../../services/Auth";

import ClientService from "../../services/Client";
import ClientSchemaReduced from "../../services/Client/SchemaReduced";

import ChipService from "../../services/Chip";

import FilterChipItem from "../FilterChipItem";
import SwitchDefault from "../Switch/Default";

const FilterChip = ({
  props: { currentUser, chips, chipsSearch, chipsSearchOnlyClient, chipsSearchQueryEnabled },
  funcs: { disableLoader, enableLoader, searchChips, setChips, setChipsSelected },
  options: { filterMultiple }
}) => {
  const { t } = useTranslation();
  const clientService = new ClientService();
  const chipService = new ChipService();

  const [switchAllChecked, setSwitchAllChecked] = useState(false);
  const [switchSingleChecked, setSwitchSingleChecked] = useState(false);
  const [_chipsSelected, _setChipsSelected] = useState([]);

  const [_chipsSearch, _setChipsSearch] = useState({
    client: JSON.parse(JSON.stringify(ClientSchemaReduced)),
    word: "",
    active: -1
  });

  const [activeOptions] = useState([
    { value: true, label: t("Active") },
    { value: false, label: t("Inactive") },
    { value: -1, label: t("All") }
  ]);

  const [clientSelectedOption, setClientSelectedOption] = useState(_chipsSearch.client.id === "" ? null : {
    dataAux: mergeObject(JSON.parse(JSON.stringify(ClientSchemaReduced)), _chipsSearch.client),
    label: _chipsSearch.client.type === "LEG" ? _chipsSearch.client.legal.socialReason : _chipsSearch.client.personal.name,
    value: _chipsSearch.client.id
  });

  useEffect(() => {
    findChips();
  }, []); /* eslint-disable-line */

  useEffect(() => {
    searchChips(_chipsSearch);
  }, [_chipsSearch]); /* eslint-disable-line */

  useEffect(() => {
    if(!switchSingleChecked) {
      if(switchAllChecked) {
        return _setChipsSelected(chipsSearchOnlyClient);
      }
      return _setChipsSelected([]);
    }
    setSwitchSingleChecked(false);
  }, [switchAllChecked]); /* eslint-disable-line */

  useEffect(() => {
    setChipsSelected(_chipsSelected);
    if(_chipsSelected.length > 0 && (chipsSearchOnlyClient.length === _chipsSelected.length)) {
      return setSwitchAllChecked(true);
    }
    setSwitchAllChecked(false);
  }, [_chipsSelected]); /* eslint-disable-line */

  const clientLoadOptions = (e, c) => {
    clientLoadOptionsDebounce(e, c);
  };

  const clientLoadOptionsDebounce = debounce(async (e, c) => {
    const clients = await clientService.findAutocomplete({ data: {
      search: e
    }, token: currentUser.token });
    c(filterClient(clients));
  }, 1000);

  const filterClient = (clients) => {
    return clients.map(e => {
      return {
        dataAux: e,
        label: e.type === "LEG" ? e.legal.socialReason : e.personal.name,
        value: e.id
      };
    });
  };

  const findChips = async () => {
    enableLoader();
    const chips = await chipService.findAll({
      data: {
        limit: 1000,
        page: 1,
        search: ""
      },
      token: currentUser.token
    });
    setChips(chips.docs);
    disableLoader();
  };

  const handleClickChip = (e, chip) => {
    if(filterMultiple) {
      return handleClickChipMultiple(e, chip);
    }
    return handleClickChipSingle(e, chip);
  };

  const handleClickChipMultiple = (e, chip) => {
    const chipsSelected = _chipsSelected.filter(x => x.id !== chip.id);
    if(!e) {
      chipsSelected.push(chip);
    }
    setSwitchSingleChecked(true);
    _setChipsSelected(chipsSelected);
  };

  const handleClickChipSingle = (e, chip) => {
    const chipsSelected = [chip];
    setSwitchSingleChecked(true);
    _setChipsSelected(chipsSelected);
  };

  return (
    <Card>
      <Card.Header>{t("Title.Chip")}</Card.Header>
      <Card.Body>
        <Row>
          {
            isScopes({ currentUser, scopes: [
              "is:master",
              "read:chips:all"
            ], every: false }) ? (
                <>
                  <Col xs={12} md={4}>
                    <Form.Group controlId="filter-chip-search-client">
                      <AsyncSelect
                        className="menu-outer-bottom menu-outer-zindex"
                        classNamePrefix="select"
                        cacheOptions
                        defaultOptions
                        isClearable
                        loadOptions={clientLoadOptions}
                        loadingMessage={() => t("React.Select.Wait")}
                        noOptionsMessage={() => t("React.Select.NoOptions")}
                        onChange={e => {
                          if(e === null) {
                            setClientSelectedOption(e);
                            _setChipsSearch(prevState => ({
                              ...prevState,
                              client: JSON.parse(JSON.stringify(ClientSchemaReduced))
                            }));
                          }
                          else {
                            const { dataAux, label, value } = e;
                            setClientSelectedOption({ dataAux, label, value });
                            _setChipsSearch(prevState => ({
                              ...prevState,
                              client: mergeObject(JSON.parse(JSON.stringify(ClientSchemaReduced)), dataAux)
                            }));
                          }
                          setSwitchAllChecked(true);
                          setTimeout(() => {
                            setSwitchAllChecked(false);
                          }, 100);
                        }}
                        placeholder={t("React.Select.SelectClient")}
                        value={clientSelectedOption}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Group controlId="filter-chip-search-chip">
                      <Form.Control
                        type="text"
                        placeholder={t("Placeholder.Search")}
                        autoComplete={"off"}
                        onChange={e => {
                          e.persist();
                          _setChipsSearch(prevState => ({
                            ...prevState,
                            word: e.target.value
                          }));
                        }}
                        value={_chipsSearch.word}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Group controlId="forms-chassi-active">
                      <Select
                        className="menu-outer-bottom"
                        classNamePrefix="select"
                        options={activeOptions}
                        onChange={e => {
                          if(e === null) {
                            _setChipsSearch(prevState => ({
                              ...prevState,
                              active: -1
                            }));
                          }
                          else {
                            _setChipsSearch(prevState => ({
                              ...prevState,
                              active: e.value
                            }));
                          }
                          setSwitchAllChecked(true);
                          setTimeout(() => {
                            setSwitchAllChecked(false);
                          }, 100);
                        }}
                        value={activeOptions.find(x => x.value === _chipsSearch.active)}
                      />
                    </Form.Group>
                  </Col>
                </>
              ) : (
                <Col>
                  <Form.Group controlId="filter-chip-search-chip">
                    <Form.Control
                      type="text"
                      placeholder={t("Placeholder.Search")}
                      autoComplete={"off"}
                      onChange={e => {
                        e.persist();
                        _setChipsSearch(prevState => ({
                          ...prevState,
                          word: e.target.value
                        }));
                      }}
                      value={_chipsSearch.word}
                    />
                  </Form.Group>
                </Col>
              )
          }
        </Row>
        <Row>
          <Col>
            <div className="filter-chip-list-all">
              {
                filterMultiple ? (
                  <div className="filter-chip-select-all">
                    <SwitchDefault title={`${t("Title.All")} (${chipsSearchQueryEnabled ? chipsSearch.length : chips.length})`} selected={switchAllChecked} onClick={e => {
                      setSwitchSingleChecked(false);
                      setSwitchAllChecked(!switchAllChecked);
                    }} />
                  </div>
                ) : null
              }
              <div className="filter-chip-list-box">
                <ul>
                  {
                    chipsSearchQueryEnabled ? (
                      chipsSearch.map(chip => {
                        const selected = _chipsSelected.find(x => x.id === chip.id) ? true : false;
                        return (
                          <FilterChipItem
                            key={`filter-chip-list-item-${chip.id}`}
                            checkbox={filterMultiple}
                            name={filterMultiple ? `filter-chip-list-item-${chip.id}` : "filter-chip-list-item"}
                            chip={chip}
                            selected={selected}
                            onClick={e => handleClickChip(selected, chip)}
                          />
                        );
                      })
                    ) : (
                      chips.map(chip => {
                        const selected = _chipsSelected.find(x => x.id === chip.id) ? true : false;
                        return (
                          <FilterChipItem
                            key={`filter-chip-list-item-${chip.id}`}
                            checkbox={filterMultiple}
                            name={filterMultiple ? `filter-chip-list-item-${chip.id}` : "filter-chip-list-item"}
                            chip={chip}
                            selected={selected}
                            onClick={e => handleClickChip(selected, chip)}
                          />
                        );
                      })
                    )
                  }
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

const mapStateToProps = state => ({
  props: {
    currentUser: state.users.currentUser,
    chips: state.chips.chips,
    chipsSearch: state.chips.chipsSearch,
    chipsSearchOnlyClient: state.chips.chipsSearchOnlyClient,
    chipsSearchQueryEnabled: state.chips.chipsSearchQueryEnabled
  }
});

const mapDispatchToProps = dispatch => ({
  funcs: bindActionCreators(Object.assign({}, LoadersActions, ChipsActions), dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(memo(FilterChip));
